import { render } from "./IPTVServicePage.vue?vue&type=template&id=340ea3bd&ts=true"
import script from "./IPTVServicePage.vue?vue&type=script&lang=ts"
export * from "./IPTVServicePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__